export const blockIconsCommunicationImportContactsNew = (
	<span className='material-symbols-outlined'>import_contacts</span>
);
